import React, { Fragment } from "react";
import ListGroup from "react-bootstrap/ListGroup";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";

const MessageList = ({ messages }) => (
  <ListGroup as="ul">
    {messages.map((message) => (
      <ListGroup.Item
        key={message.id}
        as="li"
        className="d-flex justify-content-between align-items-start"
      >
        <div className="ms-2 me-auto">
          <div className="fw-bold">
            <Badge variant="secondary">{message.To}</Badge>
          </div>
          {message.Body}
        </div>
        <div className="ms-2 me-auto">
          {message.order_id && (
            <Link to={`/fulfillments/${message.order_id}`}>
              <Badge variant="warning">{message.order_id}</Badge>
            </Link>
          )}
          <Badge variant="primary">{message.From}</Badge>
        </div>
      </ListGroup.Item>
    ))}
  </ListGroup>
);

export default MessageList;
